module.exports = __webpack_public_path__ + "static/benecaid-logo-fr-e5e77ca41721b89b1b02db68c6ec9533.png";